import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const p=t("togo",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="#006A4E" />
            <path
                d="M0 7.7002L24 7.7002V10.9002L0 10.9002L0 7.7002Z"
                fill="#FFCE00" />
            <path
                d="M0 4.5L8.89966 4.5L8.89966 15.7L0 15.7L0 4.5Z"
                fill="#D21034" />
            <path
                d="M0 14.1006L24 14.1006V17.3006L0 17.3006L0 14.1006Z"
                fill="#FFCE00" />
            <path
                d="M6.07904 9.65849L7.73556 8.36025H5.68805L5.05528 6.25977L4.42251 8.36025H2.375L4.03152 9.65849L3.39876 11.7593L5.05528 10.461L6.7118 11.7593L6.07904 9.65849Z"
                fill="white" />
        </svg>
    `),d=t("togo_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19477_118292)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M-1.8125 0.5L37.0205 0.5L37.0205 24.5L-1.8125 24.5L-1.8125 0.5Z"
                    fill="#006A4E" />
                <path
                    d="M-1.8125 5.2998L37.0205 5.2998V10.0998L-1.8125 10.0998L-1.8125 5.2998Z"
                    fill="#FFCE00" />
                <path
                    d="M-1.8125 0.5L12.5875 0.5L12.5875 17.3L-1.8125 17.3L-1.8125 0.5Z"
                    fill="#D21034" />
                <path
                    d="M-1.8125 14.9004L37.0205 14.9004V19.7004L-1.8125 19.7004L-1.8125 14.9004Z"
                    fill="#FFCE00" />
                <path
                    d="M8.29797 9.87347L10.9783 7.92611L7.66533 7.92611L6.64149 4.77539L5.61765 7.92611H2.30469L4.98501 9.87347L3.96117 13.0247L6.64149 11.0773L9.32181 13.0247L8.29797 9.87347Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19477_118292">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{p as Togo,d as TogoRounded};
